/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */	
const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const PoisonerCondition = function( instigator, owner, battleState, potency, charges ) {
	const condition = new Condition( instigator, owner, battleState, potency, charges );
	condition.handle = 'poisoner';

	const extant = BattleCalc.getCondition( owner, 'poisoner' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.setCharges = function( n ) {
		this.charges = n;
		if( n <= 0 ) {
			this.expire();
		}
	};

	return condition;
};
module.exports = PoisonerCondition
